import { Permissions, User } from '@appsvio/jira-rest-api-client';
import client from '@appsvio/jira-rest-api-client/src/forge/forgeFrontendClient';

const MAX_RESULTS_PER_PAGE = 50;

import {
    ADMINISTER_PROJECTS_PERMISSION,
    BROWSE_PROJECTS_PERMISSION,
    GLOBAL_ADMIN__PERMISSION,
    SERVICE_DESK_AGENT_PERMISSION,
} from '../../common/constants';

export const getUsersById = async (ids: string[], startAt: number = 0): Promise<Array<User>> => {
    if (ids.length === 0) return [];

    const data = await client.getUsersApi().bulkGetUsers({ accountId: ids, startAt });

    const users = data.values || [];

    if (data.isLast) {
        return users;
    } else {
        const nextUsers = await getUsersById(ids, data.startAt! + data.maxResults!);

        return users.concat(nextUsers);
    }
};

export const getIncidentBannersRelatedPermissions = async (projectId: string): Promise<Permissions> => {
    const permissions = `${GLOBAL_ADMIN__PERMISSION},${BROWSE_PROJECTS_PERMISSION},${ADMINISTER_PROJECTS_PERMISSION},${SERVICE_DESK_AGENT_PERMISSION}`;
    const perms = await client.getPermissionsApi().getMyPermissions({ projectId, permissions });

    return Promise.resolve(perms);
};

export const getIssueIdentifiers = async (
    ids: string[],
    startAt: number = 0,
    accumulatedIssues: { issueId: string; issueKey: string }[] = []
): Promise<{ issueId: string; issueKey: string }[]> => {
    try {
        const jql = `id in (${ids.map(id => id).join(', ')})`;
        const searchResults = await client.getIssueSearchApi().searchForIssuesUsingJql({
            jql,
            startAt,
            maxResults: MAX_RESULTS_PER_PAGE,
            fields: ['id', 'key'],
        });

        const issues = searchResults.issues.map(issue => ({ issueId: issue.id, issueKey: issue.key }));
        accumulatedIssues.push(...issues);

        if (searchResults.total > startAt + MAX_RESULTS_PER_PAGE) {
            return getIssueIdentifiers(ids, startAt + MAX_RESULTS_PER_PAGE, accumulatedIssues);
        } else {
            return accumulatedIssues;
        }
    } catch (error) {
        console.error('Error fetching issues:', error);
        throw error;
    }
};
